<div class="projects-container">
    <header class="projects-header">
        <div>
            <h1>My Projects</h1>
            <p>Select a project to manage workflows and configurations</p>
        </div>
        <button type="button" class="btn btn-primary" (click)="toggleCreate()">
            {{ showCreate() ? 'Cancel' : 'New project' }}
        </button>
    </header>

    @if (showCreate()) {
        <form class="create-form" [formGroup]="form" (ngSubmit)="createProject()" novalidate>
            @if (createError()) {
                <div class="state state-error" role="alert">{{ createError() }}</div>
            }
            <div class="field">
                <label for="project-name">Name</label>
                <input
                    id="project-name"
                    type="text"
                    formControlName="name"
                    [attr.aria-invalid]="isInvalid('name')"
                />
                @if (isInvalid('name')) {
                    <p class="field-error" role="alert">Name is required.</p>
                }
            </div>
            <div class="field">
                <label for="project-description">Description (optional)</label>
                <textarea
                    id="project-description"
                    rows="3"
                    maxlength="256"
                    formControlName="description"
                ></textarea>
                @if (isInvalid('description')) {
                    <p class="field-error" role="alert">
                        Description must be 256 characters or fewer.
                    </p>
                }
            </div>
            <div class="form-actions">
                <button
                    type="submit"
                    class="btn btn-primary"
                    [disabled]="form.invalid || creating()"
                >
                    {{ creating() ? 'Creating…' : 'Create project' }}
                </button>
            </div>
        </form>
    }

    @if (state() === 'loading') {
        <div class="state" role="status" aria-live="polite">Loading projects…</div>
    }

    @if (state() === 'error') {
        <div class="state state-error" role="alert">{{ loadError() }}</div>
    }

    @if (state() === 'ready') {
        @if (projects().length === 0) {
            <div class="state" role="status">You have no projects yet. Create your first one.</div>
        } @else {
            <div class="projects-grid">
                @for (project of projects(); track project.id) {
                    <div class="project-card" (click)="openProject(project.id)">
                        <div class="project-card-header">
                            <h2>{{ project.name }}</h2>
                            <button
                                type="button"
                                class="btn-delete"
                                aria-label="Delete project"
                                (click)="deleteProject(project.id, $event)"
                            >
                                Delete
                            </button>
                        </div>
                        <div class="project-card-body">
                            @if (project.description) {
                                <p>{{ project.description }}</p>
                            }
                        </div>
                    </div>
                }
            </div>
        }
    }
</div>
